<template>
  <div id="userList">
    <lySearch v-if="!hideSearch" v-model="searchItem.keyword" @search="getUserTree"></lySearch>
    <ul>
      <li @click="selectTree(item)" v-for="(item, index) in treeData" :key="item.id">

        <Tag v-for="(x, ine) in item.roleNameList" :key="x" color="blue">{{
          x
          }}</Tag>
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>
<script>
import axios from "axios";
import { Alert } from "view-design";
export default {
  props: ["noFill", "keyword", "hideSearch"],
  data() {
    return {
      treeData: [],
      searchItem: {
        keyword: "",
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.keyword = v;
      this.getUserTree();

    },

    getUserTree() {
      //this.searchItem.keyword = this.keyword;
      //alert(this.searchItem.keyword);
      this.axios({
        method: "post",
        url: axios.bm + "/user/list",
        data: this.searchItem,
      }).then((res) => {
        //this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].title = data[i].name;
        }

        this.treeData = data;

      });
    },
    selectTree(y) {
      this.$emit("user", y);
    },
  },
  mounted() {
    this.searchItem.keyword = this.keyword;
    //this.getUserTree();
  },
};
</script>
<style scoped>
#userList {
  height: 100%;
}
#userList ul {
  height: calc(100% - 50px);
  overflow: auto;
}
#userList li {
  padding: 4px 10px;
}
#userList li:hover {
  cursor: pointer;
  background: #dbe8f6;
}
</style>



// WEBPACK FOOTER //
// src/components/common/userTree.vue